import { loadSuggestedPersonas, getInitialPersonasInRootFolder } from './personaActions';
import { loadFavorites } from './favoriteLoadDataActions';
import {
    getContactFoldersAndSubscribeToChanges,
    loadContentsOfAllContactFolders,
    loadEffectiveRightsForAllPublicFolders,
} from './contactFoldersActions';
import { markPLTEvent, sequentiallyProcessPromiseFactories } from '../../../shared';

export const loadDataRequiedForDefaultView = (dispatch, sessionDataPromise: Promise<void>) => {
    const doFetchContacts = () =>
        getInitialPersonasInRootFolder(dispatch)().then(() =>
            markPLTEvent('ContactsQueryCompleted')
        );

    const doFetchFavorites = () =>
        loadFavorites(dispatch)().then(() => markPLTEvent('FavoritesQueryCompleted'));

    const doFetchFolders = () =>
        dispatch(getContactFoldersAndSubscribeToChanges).then(() =>
            markPLTEvent('FoldersQueryCompleted')
        );

    sessionDataPromise
        .then(() => markPLTEvent('BootstrapQueriesStart'))
        .then(() => {
            sequentiallyProcessPromiseFactories([
                () =>
                    Promise.all([
                        doFetchContacts(),
                        doFetchFavorites(),
                        doFetchFolders(),
                    ]).then(() => markPLTEvent('BootstrapQueriesCompleted')),
                () => loadSuggestedPersonas(dispatch),
                () => dispatch(loadContentsOfAllContactFolders),
                () => dispatch(loadEffectiveRightsForAllPublicFolders),
            ]);
        });
};
